import { Component, DestroyRef, effect, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { HuddlesService } from 'src/app/shared/services/huddle/huddles.service';
import { ActivatedRoute } from '@angular/router';
import { DatePipe, NgIf, NgFor } from '@angular/common';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { GlobalFilterService } from 'src/app/shared/services/filters/global-filter.service';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { AccountsService } from 'src/app/shared/services/accounts/accounts.service';
import { FeedsService } from 'src/app/shared/services/feeds/feeds.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { OverviewTableComponent } from '../../../../../shared/components/score/score-overview/sub-component/overview-table/overview-table.component';
import { LtmsErrorComponent } from '../../../../../shared/components/ltms-error/ltms-error.component';
import { LtmsLoaderComponent } from '../../../../../shared/components/ltms-loader/ltms-loader.component';

@Component({
    selector: 'app-all-spotlights',
    templateUrl: './all-spotlights.component.html',
    styleUrls: ['./all-spotlights.component.scss'],
    providers: [DatePipe],
    imports: [FormsModule, NgIf, NgFor, OverviewTableComponent, LtmsErrorComponent, LtmsLoaderComponent]
})
export class AllSpotlightsComponent implements OnInit {
  @ViewChild('litmussearchdropdown') litmusfeedsearch!: ElementRef;
  destroyRef = inject(DestroyRef)
  spotlightData: any[] = [];
  originalSpotlightData: any[] = [];
  filteredSpotlightData: any[] = [];
  spotlightFilteredTagField: any[] = [];
  spotlightsDataResponse: any;
  searchItem: string = '';
  huddleBrandId: string | null = null;
  spotlights: string | null = null;
  expandedRowIndex: number | null = null;
  pagination = { currentPage: 1, totalData: 0, limit: 10 };
  currentPage: number = 1;
  recordsPerPage: number = 10;
  isLoading: boolean = true;
  hidePagination: boolean = false;

  spotlightTable: any = {
    fixedHeader: [],
    header:
      [

        {
          header: "Smile Champion - (9 & 10 Smile scores)",
          uniqueId: 'tag_meeting_id',//"tag_ltms_huddle_manager_email_address_1",
          width: '200px',
          maxWidth: '200px',
          minWidth: '200px',
          isSortingEnabled: true,
          // isClickable: true,
          style: {
            header: 'flex-start',
            row: 'flex-start',
            textWrap: 'wrap'
          },
          textStyle: {
            whiteSpace: 'wrap'
          }
        },
        {
          header: "Dates",
          uniqueId: "created_date",
          width: '200px',
          maxWidth: '200px',
          minWidth: '200px',
          isSortingEnabled: true,
          // isClickable: true,
          style: {
            header: 'flex-start',
            row: 'flex-start',
            textWrap: 'wrap'
          },
          textStyle: {
            whiteSpace: 'wrap'
          }
        },
        {
          header: "Customer Testimonial/ Success Story",
          uniqueId: "comments",
          width: '700px',
          maxWidth: '700px',
          minWidth: '700px',
          isSortingEnabled: true,
          style: {
            header: 'flex-start',
            row: 'flex-start'
          },
          textStyle: {
            whiteSpace: 'wrap'
          }
        }
      ],
    rows: []
  }
  columns = [
    {
      header: 'Smile Champion - (9 & 10 Smile scores)',
      dataKey: 'managerEmail',
      enabled: true,
      dataType: 'string',
      sortable: true,
      style: {
        headerTextAlign: 'left',
        cellTextAlign: 'left',
        width: '30%'
      },
      order: 1
    },
    {
      header: 'Dates',
      dataKey: 'meetingName',
      enabled: true,
      dataType: 'string',
      isColumnSorted: true,
      sorted: false,
      sortable: true,
      style: {
        headerTextAlign: 'left',
        cellTextAlign: 'left',
        width: '25%'
      },
      order: 2
    },
    {
      header: 'Customer Testimonial/ Success Story',
      dataKey: 'comments',
      enabled: true,
      dataType: 'string',
      sortable: false,
      style: {
        headerTextAlign: 'left',
        cellTextAlign: 'left',
        width: '45%',
      },
      order: 3
    }
  ];

  // new variable declaration
  brandId: any = null;
  fromDate: any = null;
  toDate: any = null;
  brandDetails: any = {};
  spotlightConfig: any = {};
  spotlightDetails: any = {}
  spotlightBrandId: any = {}
  managerAccessDetail: any = {}
  managerHasMergeAccess: boolean = false;
  hierarchyStack: any = null;
  fieldToSearchOn: any = null
  fieldValueForSearch: any = null;
  tableConfigs: any = {
    textWrap: true,
    isExternalSort:true,
    theme: "theme-2"
  }

  filters: any = {
    sortOrder: 'desc',
    searchField: null,
    searchText: null
  }
  isDataLoaded: boolean = false;
  pagingDetails: any = {
    start: 0,
    end: 0,
    pageSize: 10,
    pageNumber: 1,
    total: 0,
    totalpages: 1
  }
  pagingButtons: any = {
    isNext: false,
    isPrevious: false,
    isLast: false,
    isFirst: false
  }

  // search variables 

  spotlightSearch: any = {
    selectedOption: {},
    selectedFilter: {},
    placeholder: "Search Employee Name",
    options: [],
  }

  searchResult: any = {}

  searchFieldConfig: any = {
    limit: 10,
    term: '',
    showFilterFields: false,
    showSearchList: false,
    isLoading: false,

  }
  clearField: any = {
    isError: false,
    displayText: 'clear',
    isEnabled: false
  }

  constructor(
    private huddlesService: HuddlesService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private _helpersService: HelpersService,
    private _toast: ToastService,
    private globalFilterService: GlobalFilterService,
    private _stateService: AppStateService,
    private _accountsService: AccountsService,
    private _feedService: FeedsService
  ) {
    effect(() => {
      if (this._stateService.initialized()) {
        const state: any = this._stateService.appState();
        if (state && this.checkRequiredPamater(state)) {
          this.fromDate = state.datePicker.startDate;
          this.toDate = state.datePicker.endDate;
          this.hierarchyStack = state.hierarchyStack;

          if (this.brandId != state.brandDetails._id) {
            this.brandDetails = state.brandDetails;
            this.brandId = state.brandDetails._id;
            if (state.hierarchyStack && state.hierarchyStack.length) {
              this.managerAccessDetail = {
                level: state.hierarchyStack[0].field_id,
                value: state.hierarchyStack[0].group_key[0]
              }
            }

            this.spotlightConfig = _.get(this.brandDetails, "action_management_configuration.huddle.modules.spotlights");
            this.spotlightBrandId = _.get(this.spotlightConfig, "config.brand_id");
            this.fieldToSearchOn = _.get(this.brandDetails, "action_management_configuration.huddle.search_config.spotlights.field_id_to_search_on");
            this.fieldValueForSearch = _.get(this.brandDetails, "action_management_configuration.huddle.search_config.spotlights.field_id_value");

            if (this.spotlightBrandId && this.spotlightBrandId != '') {
              this._accountsService.getBrandDetail(this.spotlightBrandId).subscribe((response: any) => {
                if (response && response.code == 0 && _.hasIn(response, 'data.brand') && !_.isEmpty(response.data.brand)) {
                  this.managerAccessDetail = this._helpersService.getLoggedInAccessLevelAndValue();
                  if (this.managerAccessDetail) {
                    this.managerHasMergeAccess = this.huddlesService.updateManagerHuddleMergeAccess(this.managerAccessDetail, this.brandDetails);
                  }
                  // this.initializeSearch(response.data.brand);
                  this.prepareSpotlightDetails(response.data.brand);
                  this.getSpotlightList()
                }
              })
            }
          } else if (this.spotlightBrandId && this.spotlightBrandId != '') {
            this.getSpotlightList();
          }

        }
      }
    })

  }
  ngOnInit(): void { }

  ngAfterViewInit(): void {
    document.addEventListener('click', (event) => {
      const litmusfeedsearchel: any = document.getElementById('litmusfeedsearch');
      if (litmusfeedsearchel && litmusfeedsearchel != event.target && !litmusfeedsearchel.contains(event.target)) {
        this.searchFieldConfig.showSearchList = false;
      }
      if (this.litmusfeedsearch && this.litmusfeedsearch.nativeElement !== event.target && !this.litmusfeedsearch.nativeElement.contains(event.target)) {
        this.searchFieldConfig.showSearchList = false;
      }
    });
  }

  prepareSpotlightDetails(brandDetails: any) {
    var defaultRatio = 3;
    this.spotlightDetails.brand = brandDetails;
    this.spotlightFilteredTagField=[]
    var fieldDefinitions = _.get(brandDetails, "field_definitions");
    fieldDefinitions = _.filter(fieldDefinitions, function (fieldDefinition) {
      return (_.get(fieldDefinition, "visibility_config.list") != false) ? true : false;
    });
    _.each(fieldDefinitions, (fieldsObj) =>{
      if (fieldsObj.download && !fieldsObj.is_deleted && fieldsObj.field_id != "created_date") {
        this.spotlightFilteredTagField.push({
             "field_id": "litmus_processed_data." + fieldsObj.field_id,
             "name": fieldsObj.name,
             "download": fieldsObj.download
         })
      }
     })
    let totalRatio = fieldDefinitions.map(function (fieldDefinition) {
      if (_.get(fieldDefinition, "cell_ratio.list")) {
        return _.get(fieldDefinition, "cell_ratio.list");
      } else {
        return 0;
      }
    }).reduce(function (op1, op2) {
      return op1 + op2;
    })

    this.spotlightDetails.editColumnRatio = ((10 - totalRatio) / totalRatio) * 100;
    this.spotlightDetails.fieldDefinitions = _.map(Helpers.deepClone(fieldDefinitions), function (fieldDefinition) {
      fieldDefinition["td_width"] = ((_.get(fieldDefinition, "cell_ratio.list") || defaultRatio) / totalRatio) * 100;
      return fieldDefinition;
    });

    this.columns = _.filter(Helpers.deepClone(_.get(brandDetails, "field_definitions")), (field: any) => {
      return (_.get(field, 'custom_parameter_type') == '4' && _.get(field, 'group_id') && _.get(field, 'visibility_config.list_view') == true && !field.is_huddle_information)
    })

    this.spotlightTable.header = _.map(this.columns, (field: any) => {
      let column:any = {
        header: field.title || field.name,
        uniqueId: field.field_id,
        width: this.getColumnWidth(field),
        maxWidth: this.getColumnWidth(field),
        minWidth: this.getColumnWidth(field),
        isSortingEnabled: false,
        // isClickable: true,
        style: {
          header: 'flex-start',
          row: 'flex-start',
          textWrap: (_.get(field, 'dom_options.type') == "multi-line") ? 'wrap' : ''
        },
        textStyle: {
          whiteSpace: (_.get(field, 'dom_options.type') == "multi-line") ? 'wrap' : ''
        }
      }
      if(field.field_id == "tag_ltms_huddle_c562e071-08a6-4ac9-9eb5-54ec4b1b48f0_1"){
        column.subUniqueId = 'meeting_name';
        column.sort_order = 'desc';
        column.sortId = field.field_id+"_in_ms";
        column.isSortingEnabled = true;
        this.tableConfigs.defaultSortOnColumn = column;
      }
      return column
    })
    
  }

  getColumnWidth(column:any){
    if(column.field_id == "tag_ltms_huddle_82797a2f-616e-4f2f-b4ee-808238baf0e89"){
      return '230px'
    }else if(column.field_id == "tag_ltms_huddle_c562e071-08a6-4ac9-9eb5-54ec4b1b48f0_1"){
      
      return '400px'
    }else if(column.field_id == "tag_ltms_huddle_03d0366b-7ff3-4079-8075-fecda8216d89_1" || (_.get(column, 'dom_options.type') == "multi-line")){
      return '600px'
    }else if(column.data_type == 'date'){
      return '150px'
    }else{
      return '200px'
    }
  }


  searchByField(event: any) {
    this.searchFieldConfig.isLoading = true;
    const params = this.getParametersByFilterType(this.searchFieldConfig);
    this._feedService.getFeedAndUserfilter(params).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response: any) => {
      this.searchResult = this.processSerchResult(this.fieldToSearchOn, response.data);
      this.searchFieldConfig.isLoading = false;
    });
  }

  toggleSearchList() {
    // this.searchFieldConfig.term = ''
    this.searchFieldConfig.showSearchList = true;
  }

  processSerchResult(fieldId: string, data: any) {
    var searchResults: any = [{ name: '', user_id: null }];
    var isPagination = false;
    // this.shouldShowFeedReset = true;
    if (data.code == 0) {
      // data can be in response to user data(eg. name, phone, email) or transaction data(tag_transaction_id etc)
      var options = data.data || data.feed;
      if (options && options.length) {
        searchResults = options;
        isPagination = (options.length < this.searchFieldConfig.limit) ? false : true;
      } else {
        searchResults = [{ name: 'No Results found', user_id: null, isError: true }];
        isPagination = false;
      }
    } else if (data.code == 4001) {
      // Something went wrong
      searchResults = [{ name: '', user_id: null, isError: true }];
    } else if (data.code == 4003) {
      // internal error, search type not supported
      searchResults = [{ name: 'Search type not supported', user_id: null, isError: true }];
    } else if (data.code == 5005) {
      // "Search not available"
      searchResults = [{ name: 'Search not available', user_id: null, isError: true }];
    } else if (data.code == 5000) {
      // "Unknown Exception, exception while performing search"
      searchResults = [{ name: 'Search not available', user_id: null, isError: true }];
    }

    return {
      options: _.map(searchResults, (item) => {
        if (this.isTextStartsWithTag(fieldId)) {
          if (item.feedback_request_data && !item.user_id) {
            return {
              'displayText': item.feedback_request_data[fieldId],
              'text': item.feedback_request_data[fieldId],
              'id': item.feedback_request_data[fieldId],
              isError: (item.isError) ? true : false
            }
          } else {
            return {
              'text': item.name,
              'id': item.user_id,
              isError: (item.isError) ? true : false
            }
          }
        } else {
          return {
            'displayText': item[fieldId],
            'text': (item['name'] ? item['name'] : '') + " " + (item["phone_number"] ? item["phone_number"] : '') + " " + (item["email_address"] ? item["email_address"] : ''),
            'id': item.user_id,
            isError: (item.isError) ? true : false
          }
        }
      }),
      pagination: {
        more: isPagination
      }
    }
  }

  isTextStartsWithTag(text) {
    // regular expression to check for tag_(it refers to transaction details)
    var searchPattern = new RegExp('^tag_');
    return searchPattern.test(text);
  }

  focusSearchFilter() {
    const searchEl = document.getElementById('spotlightsearchfield')

    if (this.searchFieldConfig.showSearchList) {
      this.searchFieldConfig.showSearchList = false;
    } else {
      if (searchEl) {
        searchEl.focus()
      }
      this.searchFieldConfig.showSearchList = true;
      this.spotlightSearch.placeholder = this.spotlightSearch.placeholder;
      this.searchResult = {
        options: [{
          'displayText': "Start typing to search.",
          'text': "Start typing to search.",
          'id': '',
          isError: true
        }]
      }
    }
  }

  getParametersByFilterType(params: any) {
    var order = 0;
    if (params.term) {
      params.term = params.term.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace('=', "");
    }
    return {
      brand_id: this.spotlightBrandId, //huddleActionReportVm.brandId,
      from: this.fromDate,
      to: this.toDate,
      limit: this.searchFieldConfig.limit,
      page_number: (params.page) ? params.page : 1,
      search_type: this.fieldToSearchOn,
      search_text: (params.term) ? params.term.trim() : params.term,
      feed_source_include: ["litmus_processed_data.tag_meeting_id", ("litmus_processed_data." + this.fieldToSearchOn)],
      custom_filter_list: this.getCustomFilterList()
    }
  }

  getCustomFilterList() {
    var customFilterList: any = [];
    if (this.hierarchyStack && this.hierarchyStack.length) {
      customFilterList = _.map(this.hierarchyStack, (hierarchy: any) => {
        return {
          field: hierarchy.field_id,
          value: hierarchy.group_key[0]
        }
      });
    } else if (this.managerAccessDetail && this.managerAccessDetail.level && this.managerAccessDetail.value) {
      customFilterList.push({
        "field": this.managerAccessDetail.level,
        "value": this.managerAccessDetail.value
      })
    }
    // Remove duplicates based on field
    customFilterList = _.uniq(customFilterList, "field");
    return customFilterList;
  }



  getSpotlightsforSelectedFields(item: any) {

    if (!item.isError) {
      this.pagingDetails.pageNumber = 1
      if (item.id || item.user_id) {
        this.filters.searchField = this.fieldValueForSearch;
        this.filters.searchText = item.id;
        this.searchFieldConfig.term = item.displayText || item.text;
        this.searchFieldConfig.showSearchList = false;
        this.clearField.isEnabled = true;
        this.getSpotlightList()
      } else {
        this.filters["searchField"] = null
        this.filters["searchText"] = null;
        this.searchFieldConfig.term = ''
        this.clearField.isEnabled = false;
        this.searchResult = {
          options: [{
            'displayText': "Start typing to search.",
            'text': "Start typing to search.",
            'id': '',
            isError: true
          }]
        }
        this.getSpotlightList()
      }
      this.searchFieldConfig.showSearchList = false;
    }
  }

  checkRequiredPamater(state: any) {
    if (state && _.hasIn(state, 'brandDetails') && !_.isEmpty(state.brandDetails) && _.hasIn(state, 'datePicker') && !_.isEmpty(state.datePicker) && _.hasIn(state, 'hierarchyStack') && !_.isEmpty(state.hierarchyStack)) {
      return true;
    } else {
      return false
    }
  }

  getSpotlightList(): void {
    this.isDataLoaded = false;
    this.isLoading = true
    this.spotlightTable.rows = [];
    const reqBody = {
      brand_id: this.spotlightBrandId, // Use the received spotlights data
      dimension: _.get(this.spotlightConfig, 'config.dimension'),//'litmus_processed_data.tag_ltms_huddle_manager_email_address_1',
      from: this.fromDate,
      to: this.toDate,
      hierarchy_stack: this.hierarchyStack,
      huddle_brand_id: this.brandId,
      limit: this.pagingDetails.pageSize,
      pageNumber: this.pagingDetails.pageNumber,
      search_field: this.filters.searchField,
      search_text: this.filters.searchText,
      sort_order: (this.filters && this.filters.sortOrder) ? this.filters.sortOrder : 'desc',
    };

    this.huddlesService.huddleSpotlight(reqBody).subscribe((response: any) => {
      if (response.code == 0 && _.hasIn(response, 'data.spotlight_feed.spotlights') && !_.isEmpty(response, 'data.spotlight_feed.spotlights')) {
        let spotlights = _.get(response, 'data.spotlight_feed.spotlights', []);
        let dataList = spotlights.map((result: any) => {
          let spotlight = _.get(result, '_source', {});
          let data: any = {}
          if (!_.isEmpty(spotlight)) {
            data.created_date = spotlight.created_date
            data._id = result._id
            data.litmus_processed_data = spotlight.litmus_processed_data
          }
          return data
        });
        this.spotlightTable.rows = this.prepareRowDetails(dataList)

        const total_feeds = response.data.spotlight_feed.count;
        this.updatePagingDetails(total_feeds, this.pagingDetails.pageNumber);
        if (this.pagination.totalData === 0 || this.spotlightData.length === 0) {
          this.hidePagination = true;
        } else {
          this.hidePagination = false;
        }
      }
      this.isLoading = false;
      this.isDataLoaded = true;
    },
      (error) => {
        this.isLoading = false;
        this.isDataLoaded = true;
        console.error('Error fetching huddle spotlight data:', error);
      }
    );
  }

  prepareRowDetails(feedList) {
    var meetingRowData: any = {};
    var rowDetails: any = [];
    if (feedList && feedList.length) {
      _.each(feedList, (feedData: any) => {
        if (!_.isEmpty(this.columns)) {
          var data = {};
          _.each(this.columns, (column: any) => {
            data['row_id'] = feedData._id;
            data['key'] = feedData._id;
            const colKey = column.field_id
            if (_.get(feedData, 'litmus_processed_data') || _.get(feedData, 'feedback_request_data')) {
              var tagDetails = feedData.litmus_processed_data || feedData.feedback_request_data;

              if (_.get(tagDetails, 'tag_meeting_id')) {
                data['meeting_id'] = tagDetails['tag_meeting_id'];
              }
              if (_.get(tagDetails, 'tag_meeting_name')) {
                data['meeting_name'] = tagDetails['tag_meeting_name'];
              }

              if (_.get(column, 'data_type') == 'date') {
                var dateFormat = moment(feedData.created_date).format("DD-MMM-YYYY");
                data[column.field_id] = dateFormat;
                data[column.field_id+"_in_ms"]=moment(feedData.created_date).valueOf();
              }

              if (_.get(column, 'data_type') == 'string') {

                data[colKey] = tagDetails[colKey] || "NA";

              } else {

                if (_.get(column, 'datasource.options.data_to_save_in.display_field') && _.get(column, 'datasource.options.data_to_save_in.value_field')) {
                  var datasourceOptions = column.datasource.options;

                  if (_.get(datasourceOptions, 'value_field') && _.get(datasourceOptions, 'display_field')) {
                    var dataToShow: any = [];
                    var tagdetail: any = {};

                    tagdetail[datasourceOptions.value_field] = tagDetails[datasourceOptions.data_to_save_in.value_field];
                    tagdetail[datasourceOptions.display_field] = tagDetails[datasourceOptions.data_to_save_in.display_field];

                    data[datasourceOptions.data_to_save_in.value_field] = tagDetails[datasourceOptions.data_to_save_in.value_field];
                    data[datasourceOptions.data_to_save_in.display_field] = tagDetails[datasourceOptions.data_to_save_in.display_field];

                    dataToShow.push(tagdetail);
                    tagDetails[colKey] = dataToShow;

                    // data[colKey] = tagDetails[colKey] || "NA";

                    if (_.isArray(tagDetails[colKey])) {
                      data[colKey] = _.get(tagDetails[colKey], "0." + datasourceOptions.value_field) || "NA";
                    } else {
                      data[colKey] = tagDetails[colKey] || "NA";
                    }
                  }
                }
              }
            }

          });
          if (_.get(this.brandDetails, 'action_management_configuration.huddle.modules.spotlights.config.is_edit_btn')) {
            data["editBtn"] = "";
          }
          rowDetails.push(data);
        }
      });
      return rowDetails;
    } else {
      return []
    }
  }

  getSortedData(column:any){
    this.spotlightTable.header = _.map(this.spotlightTable.header,(col:any)=>{
      if(col.uniqueId == column.uniqueId){
        col.sort_order = (column && column.sort_order)?column.sort_order:'desc'
      }
      return col;
    })
    this.filters.sortOrder = (column && column.sort_order)?column.sort_order:'desc';
    this.getSpotlightList();
  }

  spotlightResponseDownload(): void {
    const reqBody = {
      brand_id: this.brandId,
      es_index_brand_id: this.spotlightBrandId,
      from: this.fromDate,
      to: this.toDate,
      filters: [
        {
          is_tag_filter: true,
          key: "tag_private_group_" + this.managerAccessDetail.level,
          value: [this.managerAccessDetail.value],
        },
      ],
      fields:(this.spotlightFilteredTagField && this.spotlightFilteredTagField.length) ? this.spotlightFilteredTagField: [],
      tabName: "spotlights",
    };

    

    this.huddlesService.huddleDownload(reqBody).subscribe(
      (response: any) => {
        this._toast.showPopup('SUCCESS', 'Success', 'Download Request Created Successfully', 2000);
      },
      (error) => {
        console.error('Error downloading spotlight data:', error);
      }
    );
  }

  toggleFullScreen(): void {
    const elem = document.documentElement; // The whole document will go fullscreen
    if (!document.fullscreenElement) {
      elem.requestFullscreen().catch(err => {
        console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
      });
    } else {
      document.exitFullscreen().catch(err => {
        console.error(`Error attempting to disable full-screen mode: ${err.message} (${err.name})`);
      });
    }
  }


  paginateFeedList(pagingType: string) {
    if (pagingType == 'next') {
      this.pagingDetails["pageNumber"]++;
    } else if (pagingType == 'previous') {
      this.pagingDetails["pageNumber"]--;
    } else if (pagingType == 'first') {
      this.pagingDetails["pageNumber"] = 1;
    } else if (pagingType == 'last') {
      this.pagingDetails["pageNumber"] = this.pagingDetails.totalpages;
    }
    this.getSpotlightList()
  }

  updatePagingDetails(totalfeeds: number, pageNumber: number) {
    if (totalfeeds > this.pagingDetails.pageSize) {
      pageNumber = (pageNumber > 0) ? pageNumber : 1;
      let start = (pageNumber > 0) ? ((pageNumber - 1) * this.pagingDetails.pageSize) + 1 : 1;
      let end = (pageNumber > 0) ? (pageNumber * this.pagingDetails.pageSize) : this.pagingDetails.pageSize;
      end = (pageNumber >= this.pagingDetails.totalpages) ? ((pageNumber - 1) * this.pagingDetails.pageSize) + this.spotlightTable.rows.length : end;
      this.pagingDetails = {
        start: start,
        end: end,
        pageSize: 10,
        pageNumber: pageNumber,
        total: totalfeeds,
        totalpages: Math.ceil(totalfeeds / 10)
      }
    } else {
      this.pagingDetails = {
        start: (totalfeeds > 0) ? 1 : 0,
        end: (totalfeeds > 0) ? totalfeeds : 0,
        pageSize: 10,
        pageNumber: 1,
        total: (totalfeeds > 0) ? totalfeeds : 0,
        totalpages: 1
      }
    }
    this.pagingDetails.total = totalfeeds;
    this.pagingButtons.isNext = false;
    this.pagingButtons.isFirst = false;
    this.pagingButtons.isPrevious = false;
    this.pagingButtons.isLast = false;

    if (this.pagingDetails.pageNumber < this.pagingDetails.totalpages) {
      this.pagingButtons.isNext = true;
      this.pagingButtons.isLast = true;
    }

    if (this.pagingDetails.pageNumber > 1) {
      this.pagingButtons.isFirst = true;
      this.pagingButtons.isPrevious = true;
    }

    if (this.pagingDetails.total < this.pagingDetails.pageSize) {
      this.pagingButtons.isNext = false;
      this.pagingButtons.isFirst = false;
      this.pagingButtons.isPrevious = false;
      this.pagingButtons.isLast = false;
    }
  }

}
